import { eachDay, format, parse, startOfDay } from "date-fns";
import wencoDemoModeConfig from "./wencoDemoModeConfig.json";
import wencoDemoData from "./wencoDemoData.json";
import wencoDemoDataMinimal from "./wencoDemoData.minimal.json";

export const WENCO_DEMO_MODE_CHANGED = "trackcode.wencoDemoMode.changed";

export function isWencoDemoModeEnabled() {
  try {
    return (
      localStorage.getItem(wencoDemoModeConfig.storageKey) === "true"
    );
  } catch (error) {
    return false;
  }
}

export function setWencoDemoModeEnabled(enabled) {
  try {
    localStorage.setItem(
      wencoDemoModeConfig.storageKey,
      String(Boolean(enabled))
    );
  } catch (error) {
    // ignore storage errors
  }
  if (typeof window !== "undefined") {
    window.dispatchEvent(
      new CustomEvent(WENCO_DEMO_MODE_CHANGED, {
        detail: { enabled: Boolean(enabled) }
      })
    );
  }
}

export function hasWencoDemoModeAccess(managedLogisticCompanies = {}) {
  return wencoDemoModeConfig.enabledForLogisticCompanyIds.some(
    id => !!managedLogisticCompanies[id]
  );
}

function getActiveWencoDemoData() {
  return wencoDemoModeConfig.dataVariant === "minimal"
    ? wencoDemoDataMinimal
    : wencoDemoData;
}

export function getWencoDemoMembers() {
  return getActiveWencoDemoData().members || [];
}

function mapDateToBesuchstag(date) {
  const day = new Date(date).getDay();
  const mapping = {
    0: "7",
    1: "1",
    2: "2",
    3: "3",
    4: "4",
    5: "5",
    6: "6"
  };
  return mapping[day] || null;
}

function applyDateToDateTime(value, dateString) {
  if (!value) return "";
  const [, time = "00:00"] = String(value).split(" ");
  return `${dateString} ${time}`;
}

export function getWencoDemoShipmentsResult(
  date = getWencoDemoDate(),
  endDate = date
) {
  const rangeStart = startOfDay(date);
  const rangeEnd = startOfDay(endDate);
  const days =
    rangeEnd < rangeStart ? [rangeStart] : eachDay(rangeStart, rangeEnd);

  const byUid = new Map();
  days.forEach(day => {
    const dateString = format(day, "YYYY-MM-DD");
    const besuchstag = mapDateToBesuchstag(day);
    (getActiveWencoDemoData().shipments || [])
      .filter(shipment => {
        if (!besuchstag) return true;
        return String(shipment?.wenco?.besuchstag || "") === besuchstag;
      })
      .forEach(shipment => {
        const baseId = shipment.id;
        const rowId = `${baseId}-${dateString}`;
        byUid.set(rowId, {
          ...shipment,
          id: rowId,
          pickup_appointment_from: applyDateToDateTime(
            shipment.pickup_appointment_from,
            dateString
          ),
          pickup_appointment_till: applyDateToDateTime(
            shipment.pickup_appointment_till,
            dateString
          ),
          delivery_appointment_from: applyDateToDateTime(
            shipment.delivery_appointment_from,
            dateString
          ),
          delivery_appointment_till: applyDateToDateTime(
            shipment.delivery_appointment_till,
            dateString
          ),
          update_datetime: `${dateString} 08:00:00`
        });
      });
  });

  return {
    shipments: [...byUid.values()]
  };
}

/** Local start-of-day for demo appointments (avoids UTC `YYYY-MM-DD` parsing). */
export function getWencoDemoDate() {
  return startOfDay(
    parse(wencoDemoModeConfig.demoDate, "YYYY-MM-DD", new Date())
  );
}

export function isWencoMapCustomersEnabled() {
  return wencoDemoModeConfig?.map?.showCustomers !== false;
}

export { wencoDemoModeConfig, wencoDemoData, wencoDemoDataMinimal };
